module.exports = __webpack_public_path__ + "static/media/ImageX.13a42a5f.gif";